import { SITE } from './siteConfig';

// `answer` is plain text: rendered on the page and reused verbatim in FAQPage JSON-LD.
export const FAQS = [
    {
        question: 'What types of services do you offer?',
        answer: 'We offer a full range of general contracting and remodeling services for your home. This includes general repairs, kitchen and bathroom remodels, interior and exterior painting, carpentry, drywall repair, fixture installations, and full interior remodels.',
    },
    {
        question: 'Are you licensed and insured general contractors?',
        answer: `Yes, we are fully licensed and insured general contractors (Florida license ${SITE.license}). We meet all state and local requirements to ensure your project is completed safely, legally, and to the highest standards.`,
    },
    {
        question: 'How do I schedule an appointment?',
        answer: `Scheduling is quick and easy. Book directly online, call us at ${SITE.phone}, or send us a message through our Contact Us page.`,
    },
    {
        question: 'Do you offer free estimates?',
        answer: 'Yes, we offer free estimates for all renovation projects. For small repair jobs and emergency calls, we charge a service call fee to assess the situation and provide the necessary assistance.',
    },
    {
        question: 'What areas in South Florida do you serve?',
        answer: 'We serve Boca Raton, Delray Beach, Highland Beach, Boynton Beach, Lake Worth Beach and Greenacres, plus Parkland, Coconut Creek, Coral Springs, Pompano Beach, Deerfield Beach, Hillsboro Mile and Lighthouse Point.',
    },
    {
        question: 'Are you available for emergency repairs?',
        answer: `Yes. We are available 24/7. Call ${SITE.phone} and our team will respond as quickly as possible.`,
    },
];
